import { mapState, mapGetters } from 'vuex'
export default {
  // Mixin for financial services blocks
  // Required methods:
  // initFinancing()
  // requestFinancing()
  // retrieveText()
  // Required store getter: showInPdf
  // Required proeprty: productTypeDictionaryFolder

  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showFinancialServiceConfig: false,
      financingIsLoading: false,
      showInPdf: false,
    }
  },
  computed: {
    ...mapState('quote', ['quote']),
    ...mapState('user', ['dealerSettings']),
    ...mapState('configuration', ['configuration']),
    ...mapGetters({
      isReadOnly: 'quote/quoteStatusIsSalesOrder',
      configurationIsUpdating: 'configuration/isUpdating',
    }),
  },
  provide() {
    return {
      retrieveText: this.retrieveText,
      retrieveModalText: this.retrieveModalText,
      retrieveInfoText: this.retrieveInfoText,
    }
  },
  mounted() {
    window.VUE_CLI_EXPORTS.plugins.EventBus.$on('configuration-loaded', this.initFinancing)
  },
  unmounted() {
    window.VUE_CLI_EXPORTS.plugins.EventBus.$off('configuration-loaded', this.initFinancing)
  },
  methods: {
    showConfigModal(show) {
      this.showFinancialServiceConfig = show
    },
    setFinancingIsLoading(isLoading) {
      this.financingIsLoading = isLoading
    },
    handleUpdateFinancing(param, value) {
      if (this.financialParams[param]?.value || this.financialParams[param]?.value === 0) {
        this.financialParams[param].value = value
      } else {
        this.financialParams[param] = value
      }
      this.requestFinancing()
    },
    retrieveModalText(label, params) {
      return this.retrieveText(`modal/${label}`, params)
    },
    retrieveInfoText(labelName, params = null) {
      let productTypePrefix = !!this.productTypeDictionaryFolder
        ? `${this.productTypeDictionaryFolder}/`
        : ''
      return this.retrieveModalText(`${productTypePrefix}${labelName}`, params)
    },
  },
}
